import { Slice } from '@tiptap/pm/model';
import type { Transaction } from '@tiptap/pm/state';
import type { EditorView } from '@tiptap/pm/view';
import { docToMarkdown, stateToMarkdown } from './stateToMarkdown';
import { descriptionChangeAllowed } from './descriptionText';

export function clipDescriptionPaste(view: EditorView, tr: Transaction): Transaction | null {
  const state = view.state;
  const step = tr.steps[0] as { slice?: Slice };
  const slice = step?.slice;
  if (!slice) return null;
  const current = stateToMarkdown(state);
  let clipped: Transaction | null = null;
  let low = 1;
  let high = slice.content.size;
  while (low <= high) {
    const middle = Math.floor((low + high) / 2);
    try {
      const partial = Slice.maxOpen(slice.content.cut(0, middle));
      const candidate = state.tr.replaceSelection(partial);
      const markdown = docToMarkdown(candidate.doc, state.schema);
      const hasUnpairedSurrogate = Array.from(markdown).some(character =>
        character.length === 1 && character.charCodeAt(0) >= 0xd800 && character.charCodeAt(0) <= 0xdfff
      );
      if (!hasUnpairedSurrogate && descriptionChangeAllowed(markdown, current) && markdown !== current) {
        clipped = candidate;
        low = middle + 1;
      } else {
        high = middle - 1;
      }
    } catch {
      high = middle - 1;
    }
  }
  return clipped;
}
